import { useRef } from "react";

const useDebouncedClick = (singleClickHandler, doubleClickHandler, delay = 250) => {
  const clickTimeout = useRef(null);
  const clickCount = useRef(0);

  const handleClick = (event) => {
    clickCount.current += 1; 

    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      if (clickCount.current === 1) {
        console.log("1 klik");
        singleClickHandler(event);
      } else if (clickCount.current === 2) {
        console.log("2 klika");
        doubleClickHandler(event);
      }
      clickCount.current = 0; 
    }, delay);
  };

  return handleClick;
};

export default useDebouncedClick;
